"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  /*'/questions': {
  	title: 'FAQ',
  	view: 'Faq',
  	public: true,
  	locales: {
  		az: '/az/questions',
  		en: '/en/questions',
  		ru: '/ru/questions',
  	}
  },
  '/az/questions': {ref: '/questions', lang: 'az', title: 'FAQ'},
  '/en/questions': {ref: '/questions', lang: 'en', title: 'FAQ'},
  '/ru/questions': {ref: '/questions', lang: 'ru', title: 'FAQ'},*/
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vbGlicmFyeS9zcmMtY2xpZW50L21vZHVsZXMvQ29udGVudC9RdWVzdGlvbi9RdWVzdGlvblJvdXRlcy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG5cdC8qJy9xdWVzdGlvbnMnOiB7XG5cdFx0dGl0bGU6ICdGQVEnLFxuXHRcdHZpZXc6ICdGYXEnLFxuXHRcdHB1YmxpYzogdHJ1ZSxcblx0XHRsb2NhbGVzOiB7XG5cdFx0XHRhejogJy9hei9xdWVzdGlvbnMnLFxuXHRcdFx0ZW46ICcvZW4vcXVlc3Rpb25zJyxcblx0XHRcdHJ1OiAnL3J1L3F1ZXN0aW9ucycsXG5cdFx0fVxuXHR9LFxuXHQnL2F6L3F1ZXN0aW9ucyc6IHtyZWY6ICcvcXVlc3Rpb25zJywgbGFuZzogJ2F6JywgdGl0bGU6ICdGQVEnfSxcblx0Jy9lbi9xdWVzdGlvbnMnOiB7cmVmOiAnL3F1ZXN0aW9ucycsIGxhbmc6ICdlbicsIHRpdGxlOiAnRkFRJ30sXG5cdCcvcnUvcXVlc3Rpb25zJzoge3JlZjogJy9xdWVzdGlvbnMnLCBsYW5nOiAncnUnLCB0aXRsZTogJ0ZBUSd9LCovXG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztvQ0FBZTtFQUNkO0FBQ0Q7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBWkMsQ0FhQSIsImlnbm9yZUxpc3QiOltdfQ==